import { ApolloQueryResult } from "@apollo/client"
import { Save } from "@mui/icons-material"
import { Grid, IconButton, Typography } from "@mui/material"
import { Form, Formik } from "formik"
import { SurveyRecordQuery, useCreateOneSurveyRecordVerificationMutation } from "../../generated/graphql"
import { useGtXs } from "../../hooks/useGtXs"
import useToast from "../../hooks/useToast"
import InputTextField from "../InputTextField/InputTextField"
import Show from "../Show/Show"
import surveyRecordVerificationFormInit from "../SurveyRecordVerification/SurveyRecordVerificationFormInit"
import SurveyRecordVerificationClassificationField from "../SurveyRecordVerificationClassificationField/SurveyRecordVerificationClassificationField"
import VerificationField from "../VerificationField/VerificationField"
import VerificationScopeField from "../VerificationScopeField/VerificationScopeField"
import styles from './CreateSurveyRecordVerification.module.scss'

interface CreateSurveyRecordVerificationProps {
    surveyRecord: any
    isNotUserEdit: boolean
    refetch: () => Promise<ApolloQueryResult<SurveyRecordQuery>>
}

export default function CreateSurveyRecordVerification(props: CreateSurveyRecordVerificationProps) {
    const { surveyRecord, isNotUserEdit, refetch } = props

    const { schema, initial } = surveyRecordVerificationFormInit()
    const { feedback } = useToast()
    const [create] = useCreateOneSurveyRecordVerificationMutation()
    const gtXs = useGtXs()

    const handleSubmit = async (values: any, helpers: any) => {
        const { description, surveyRecordVerificationState, verification, surveyRecordVerificationClassification } = values
        const response = await create({
            variables: {
                input: {
                    surveyRecordVerification: {
                        surveyRecord: surveyRecord?.id,
                        verification: verification?.id,
                        description,
                        surveyRecordVerificationClassification: surveyRecordVerificationClassification?.id,
                        surveyRecordVerificationState: surveyRecordVerificationState?.id
                    }
                }
            }
        })
        feedback(!response?.errors?.length, "Linha criada com sucesso", "Erro ao criar linha")
        helpers?.resetForm()
        refetch()
    }

    return (
        <Formik initialValues={initial} onSubmit={handleSubmit} validationSchema={schema} validateOnBlur={false} validateOnChange={false} validateOnMount={false}>
            {({ values }) => {
                return (
                    <div>
                        <Typography variant="h6" color="secondary">
                            Criar Verificação
                        </Typography>
                        <Form>
                            <Grid container direction={gtXs ? "row" : "column"} className={styles.CreateSurveyRecordVerification} alignItems={gtXs ? "flex-end" : "flex-start"}>
                                <span style={{ minWidth: gtXs ? 120 : 250, marginRight: 30 }}>
                                    <VerificationScopeField autoFocus={gtXs} disabled={isNotUserEdit} />
                                </span>
                                <span style={{ minWidth: gtXs ? 250 : 250, maxWidth: 250, marginRight: 30 }}>
                                    <VerificationField scope={values?.verificationScope?.id} disabled={isNotUserEdit} />
                                </span>
                                <span style={{ minWidth: gtXs ? 600 : 250, marginRight: 30 }}>
                                    <InputTextField
                                        name="description"
                                        multiline
                                        minRows={1}
                                        maxRows={5}
                                        fullWidth
                                        label="descrição"
                                        disabled={isNotUserEdit} />
                                </span>

                                <span style={{ minWidth: 250, marginRight: 30 }}>
                                    <SurveyRecordVerificationClassificationField disabled={isNotUserEdit} />
                                </span>

                                <Show on={gtXs}>
                                    <IconButton type="submit" disabled={isNotUserEdit}>
                                        <Save fontSize="small" />
                                    </IconButton>
                                </Show>


                                <Show on={!gtXs}>
                                    <Grid container justifyContent="flex-end" alignItems="center">
                                        <IconButton type="submit" disabled={isNotUserEdit}>
                                            <Save fontSize="small" style={{ marginRight: -10, marginTop: 5 }} />
                                        </IconButton>
                                    </Grid>
                                </Show>

                            </Grid>
                        </Form>
                    </div>
                )
            }}
        </Formik>
    )
}
